import React from 'react';
import logo from '../../images/sport/generic/Logo.svg';
import RemoteImage from '../remote_img/remote_img';
import { SPORT_LIST } from '../../javascript/services/globalVars';

function LogoImg(Props) {
   const sport = Props.sport;
   const sport_obj = SPORT_LIST.find(i => i.id === sport);
   const logo_image = typeof sport_obj !== 'undefined'?  sport_obj.image : logo;
   return (
      <RemoteImage className={Props.className} src={logo_image} alt="logo"></RemoteImage>
   );
}

export default LogoImg;